import React from 'react'

interface IProps {
  className?: string
  color?: string
}

const BackgroundWave: React.FC<IProps> = ({ className, color = '#EFEDF8' }) => (
  <svg
    className={className}
    viewBox="0 0 1440 468"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1440 0S789.144 327.336 0 192.895V468h1440V0Z" fill={color} />
  </svg>
)

export default BackgroundWave
